import { useCallback, useState } from 'react';

// Modal visibility state.
const useModals = (): any[] => {
    // Modal visibility state.
    // values: '', 'save-selector', 'save-features',
    //  'load-favourite', 'paste-features', 'copy-features'
    const [modal, showModal] = useState<string>('');
    const hideModals = useCallback(() => {
        showModal('');
    }, [showModal]);
    return [modal, showModal, hideModals];
};
export default useModals;
